import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cn from 'classnames';
import { Card, Typography, Button } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from './GraphWidgetBottomCard.module.scss';
/** Renders a card for the 2nd row of a graph widget. */ export default function GraphWidgetBottomCard(props) {
    const { className, children, empty, emptyMsg, loading, loadingMsg, loadingOrEmptyBg, error, onRefresh, testId } = props, rest = _object_without_properties(props, [
        "className",
        "children",
        "empty",
        "emptyMsg",
        "loading",
        "loadingMsg",
        "loadingOrEmptyBg",
        "error",
        "onRefresh",
        "testId"
    ]);
    const { t: dashTexts } = useLocaleKeys('home.dashboard');
    const getLoadingMessage = ()=>loading ? /*#__PURE__*/ _jsx(Typography, {
            className: styles.loadingText,
            children: loadingMsg
        }) : emptyMsg != null ? /*#__PURE__*/ _jsx(Typography, {
            className: styles.loadingText,
            children: emptyMsg
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: loadingMsg
        });
    if (error) {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.error,
            "data-testid": testId && "".concat(testId, "-error"),
            children: [
                errorIcon,
                /*#__PURE__*/ _jsx(Typography, {
                    children: dashTexts.graphError()
                }),
                /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'refresh_graph_widget'
                    },
                    testId: testId && "".concat(testId, "-refresh"),
                    onClick: onRefresh,
                    children: "Refresh"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({}, rest), {
        bi: {
            name: 'graph_widget_bottom_card'
        },
        testId: testId,
        className: cn(styles.root, className),
        children: loading || empty ? /*#__PURE__*/ _jsxs("div", {
            className: styles.loading,
            "data-testid": testId && "".concat(testId, "-").concat(loading ? 'loading' : 'empty'),
            children: [
                loadingOrEmptyBg && loadingOrEmptyBg(),
                getLoadingMessage()
            ]
        }) : children
    }));
}
const errorIcon = /*#__PURE__*/ _jsxs("svg", {
    width: "145",
    height: "144",
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ _jsx("g", {
            filter: "url(#filter0_dd_181_18775)",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M104.768 38.1234C105.834 36.8972 107.38 36.1931 109.004 36.1931H120.128C122.337 36.1931 124.128 37.9839 124.128 40.1931V115.335H106.112L104.535 39.3685L104.768 38.3647V38.1234Z",
                fill: "url(#paint0_linear_181_18775)"
            })
        }),
        /*#__PURE__*/ _jsx("g", {
            filter: "url(#filter1_dd_181_18775)",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M77.0116 58.6328C77.9286 57.5609 79.2687 56.9438 80.6793 56.9438H92.1376C94.3467 56.9438 96.1376 58.7347 96.1376 60.9438V115.335H78.1215L76.7783 59.3567L77.0116 58.6328Z",
                fill: "url(#paint1_linear_181_18775)"
            })
        }),
        /*#__PURE__*/ _jsx("g", {
            filter: "url(#filter2_dd_181_18775)",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M49.0223 73.5927C49.9393 72.5208 51.2794 71.9037 52.6901 71.9037H64.1483C66.3575 71.9037 68.1483 73.6945 68.1483 75.9037V115.335H50.1322L48.7891 74.3166L49.0223 73.5927Z",
                fill: "url(#paint2_linear_181_18775)"
            })
        }),
        /*#__PURE__*/ _jsx("g", {
            filter: "url(#filter3_dd_181_18775)",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M21.033 83.7267C21.9501 82.6548 23.2901 82.0377 24.7008 82.0377H36.1591C38.3682 82.0377 40.1591 83.8286 40.1591 86.0377V115.335H22.143L20.7998 84.4506L21.033 83.7267Z",
                fill: "url(#paint3_linear_181_18775)"
            })
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M104.535 41.1583C104.535 38.9491 106.326 37.1583 108.535 37.1583H119.195C121.404 37.1583 123.195 38.9492 123.195 41.1583V115.335H104.535V41.1583Z",
            fill: "#FCFCFD"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M76.5459 61.9091C76.5459 59.7 78.3368 57.9091 80.5459 57.9091H91.2054C93.4146 57.9091 95.2054 59.6999 95.2054 61.9091V115.336H76.5459V61.9091Z",
            fill: "#FCFCFD"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M48.5557 76.8688C48.5557 74.6597 50.3465 72.8688 52.5557 72.8688H63.2152C65.4243 72.8688 67.2152 74.6597 67.2152 76.8688V115.335H48.5557V76.8688Z",
            fill: "#FCFCFD"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M20.5674 87.0029C20.5674 84.7938 22.3582 83.0029 24.5674 83.0029H35.2269C37.436 83.0029 39.2269 84.7938 39.2269 87.0029V115.335H20.5674V87.0029Z",
            fill: "#FCFCFD"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M11.0039 87.2734C11.0039 87.2734 48.7894 92.3404 83.3095 71.5897C117.83 50.839 123.333 28.9291 123.333 28.9291",
            stroke: "#6942F8",
            strokeWidth: "3",
            strokeLinecap: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M119.218 30.3093L123.627 28.1765L125.583 32.5041",
            stroke: "#6942F8",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M11 115.697L131 115.697",
            stroke: "#282863",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ _jsxs("defs", {
            children: [
                /*#__PURE__*/ _jsxs("filter", {
                    id: "filter0_dd_181_18775",
                    x: "84.5352",
                    y: "6.19308",
                    width: "59.5928",
                    height: "137.142",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "-10"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "8"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_181_18775",
                            result: "effect2_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_181_18775",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("filter", {
                    id: "filter1_dd_181_18775",
                    x: "56.7783",
                    y: "26.9438",
                    width: "59.3594",
                    height: "116.392",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "-10"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "8"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_181_18775",
                            result: "effect2_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_181_18775",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("filter", {
                    id: "filter2_dd_181_18775",
                    x: "28.7891",
                    y: "41.9037",
                    width: "59.3594",
                    height: "101.432",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "-10"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "8"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_181_18775",
                            result: "effect2_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_181_18775",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("filter", {
                    id: "filter3_dd_181_18775",
                    x: "0.799805",
                    y: "52.0377",
                    width: "59.3594",
                    height: "91.2977",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "-10"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "8"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "10"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "effect1_dropShadow_181_18775",
                            result: "effect2_dropShadow_181_18775"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect2_dropShadow_181_18775",
                            result: "shape"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint0_linear_181_18775",
                    x1: "99.7565",
                    y1: "44.69",
                    x2: "109.722",
                    y2: "62.7707",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#DCE0F4"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.247812",
                            stopColor: "white"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.303741",
                            stopColor: "#E9ECFF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.529511",
                            stopColor: "#DDE2FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.673845",
                            stopColor: "#CED6FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.740917",
                            stopColor: "#C1CAFB"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#C2C8EB"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint1_linear_181_18775",
                    x1: "71.7664",
                    y1: "63.2129",
                    x2: "77.8359",
                    y2: "78.1375",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#DCE0F4"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.247812",
                            stopColor: "white"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.303741",
                            stopColor: "#E9ECFF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.529511",
                            stopColor: "#DDE2FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.673845",
                            stopColor: "#CED6FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.740917",
                            stopColor: "#C1CAFB"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#C2C8EB"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint2_linear_181_18775",
                    x1: "43.7772",
                    y1: "78.1727",
                    x2: "49.8466",
                    y2: "93.0974",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#DCE0F4"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.247812",
                            stopColor: "white"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.303741",
                            stopColor: "#E9ECFF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.529511",
                            stopColor: "#DDE2FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.673845",
                            stopColor: "#CED6FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.740917",
                            stopColor: "#C1CAFB"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#C2C8EB"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("linearGradient", {
                    id: "paint3_linear_181_18775",
                    x1: "15.7879",
                    y1: "88.3068",
                    x2: "21.8574",
                    y2: "103.231",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#DCE0F4"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.247812",
                            stopColor: "white"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.303741",
                            stopColor: "#E9ECFF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.529511",
                            stopColor: "#DDE2FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.673845",
                            stopColor: "#CED6FF"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "0.740917",
                            stopColor: "#C1CAFB"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            offset: "1",
                            stopColor: "#C2C8EB"
                        })
                    ]
                })
            ]
        })
    ]
});
